import React from "react";

import { RoleCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function role({ width, onResize }: Column.Options) {
	return base(ColumnId.Role, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default role;
